import { SvgIcon, SvgIconProps } from '@mui/material';

const VpnKeyIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props} viewBox="0 0 37 20" fill="none">
      <path
        d="M10.167 20C7.38921 20 5.0281 19.0278 3.08366 17.0833C1.13921 15.1389 0.166992 12.7778 0.166992 10C0.166992 7.22222 1.13921 4.86111 3.08366 2.91667C5.0281 0.972222 7.38921 0 10.167 0C12.5095 0 14.521 0.664306 16.2016 1.99292C17.8821 3.32181 19.0466 4.94458 19.6949 6.86125H36.8337V13.1388H32.7782V20H27.0557V13.1388H19.6949C19.0466 15.0554 17.8821 16.6782 16.2016 18.0071C14.521 19.3357 12.5095 20 10.167 20ZM10.167 13C11.0095 13 11.7202 12.7107 12.2991 12.1321C12.8777 11.5532 13.167 10.8425 13.167 10C13.167 9.1575 12.8777 8.44681 12.2991 7.86792C11.7202 7.28931 11.0095 7 10.167 7C9.32449 7 8.6138 7.28931 8.03491 7.86792C7.4563 8.44681 7.16699 9.1575 7.16699 10C7.16699 10.8425 7.4563 11.5532 8.03491 12.1321C8.6138 12.7107 9.32449 13 10.167 13Z"
        fill="currenColor"
      />
    </SvgIcon>
  );
};

export default VpnKeyIcon;
